import React, { useState, useEffect } from "react";
import Scheduler, { SchedulerData, ViewTypes, SummaryPos, DATE_FORMAT } from "react-big-scheduler";
import moment from "moment";
import "moment/locale/it";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Button from '@mui/material/Button';
import withDragDropContext from "./withDnDContext";
import { useNotify, useDataProvider, ConfirmClasses } from 'react-admin';
import "react-big-scheduler/lib/css/style.css";
import { useRefresh } from 'react-admin';
import {Typography} from '@mui/material';
import { useEditContext,useGetOne,useGetMany,useGetManyReference } from 'react-admin';
import {ThreeDots} from 'react-loader-spinner';

const DashboardWeeklyView_7 =  ({ enteId }) => {
  //const refresh = useRefresh();
  const [loading, setLoading]= useState(true);  
  //const [enteId, setEnteId] = useState(48);          
  
  const [dataAttivita, setDataAttivita] = useState(moment().startOf('week').format("YYYY-MM-DD"));
  
  //let totale;
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [isPopoverVisible, setIsPopoverVisible] = useState(true);  

  //SLOTS tutti
  const { data: slots, isPending2, error2 } = useGetManyReference(
      'slots',
      { 
          target: 'ente_id',
          id: enteId,     
          filter: {            
            ambito_id: 7,       
          },     
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'giorno', order: 'DESC' }
      }
  );
  
  

  const { data: prenotazioni, isPending, error } = useGetManyReference(
    'prenotazioni_7',
    { 
        target: 'ente_id',
        id: enteId,
        filter: {            
            //data_attivita: dataAttivita,                          
            data_attivita_gte: dataAttivita, 
            data_attivita_lte: moment(dataAttivita).add(6, 'days').format('YYYY-MM-DD'),               
            stato_prenotazione_id_neq: 3                     
          },
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'bambino_id', order: 'DESC' }
    }
  );






  const getSummary = (schedulerData, headerEvents, slotId, slotName, headerStart, headerEnd) => {
 
  }

  

  const createSchedulerData = (events = [], resources = []) => {    
    const scheduler = new SchedulerData(
      dataAttivita,  
      ViewTypes.Day,
      false,
      false,
      {
        dayStartFrom: 7,
        dayStopTo: 19,
        isEventPerspective: true,
        views: [],
        nonAgendaOtherCellHeaderFormat: "ddd D/M",
        resourceName: "Disponibilità",
        schedulerWidth: "90%",
        //agendaResourceTableWidth:"450",
        //resourceTableWidth: "450", 
        dayResourceTableWidth:350,
        startResizable: false,
        endResizable: false,
        movable: false,
        creatable: false,
        nonWorkingTimeHeadBgColor:"white",
        nonWorkingTimeBodyBgColor:"white",
        nonWorkingTimeHeadColor:"black",   
        dayResourceTableWidth:400,   
        schedulerWidth:"100", 
        //getSummaryFunc: getSummary,
        
      }
    );
    
    scheduler.setResources(resources); 
    scheduler.setEvents(events);    
    //scheduler.behaviours.isNonWorkingTimeFunc = isNonWorkingTime;
    //scheduler.behaviors.isNonWorkingTimeFunc= isNonWorkingTime;
    scheduler.config.summaryPos = SummaryPos.Top;
    scheduler.behaviors.getSummaryFunc=getSummary;
   
    scheduler.behaviors.getEventItemBgColor = (schedulerData, event) => {
      console.log("CALLING ADDD",schedulerData, event);
      const slotName = schedulerData.getSlotById(event.resourceId)?.name || "";
      
      // Se la riga è il sabato, imposta il colore di sfondo rosso
      return slotName.toLowerCase().includes("sabato") ? "red" : undefined;
    };

    //scheduler.eventItemPopoverTemplateResolver = eventItemPopoverTemplateResolver;
    return scheduler;
};
 
 const [schedulerData, setSchedulerData] = useState(createSchedulerData([], []));
  


const generateTimeSlots = (startDate) => {
  const timeslots = [];
  let id = 0; 
  const startHour = 7;
  const endHour = 20;
  const intervalMinutes = 30;
  //const days = 6; 
  const days = 7; 

  for (let day = 0; day < days; day++) {
    const realDate = moment(startDate).add(day, "days").format("YYYY-MM-DD");
    const currentDate = moment(startDate).format("YYYY-MM-DD");

    for (let hour = startHour; hour < endHour; hour++) {
      for (let minute of [0, intervalMinutes]) {
        const start = moment(`${currentDate} ${hour}:${minute}:00`, "YYYY-MM-DD HH:mm:ss");
        const end = start.clone().add(intervalMinutes, "minutes");
        const real_start=moment(`${realDate} ${hour}:${minute}:00`, "YYYY-MM-DD HH:mm:ss");
        const real_end=real_start.clone().add(intervalMinutes, "minutes");
        timeslots.push({
          id: parseInt(id++)%26,
          resourceId: day,
          start: start.format("YYYY-MM-DD HH:mm:ss"),
          end: end.format("YYYY-MM-DD HH:mm:ss"),
          title: "",
          bgColor: "grey",
          label:  moment(startDate).add(day, "days").format("dddd") + " "+moment(startDate).add(day, "days").format("DD/MM/YYYY"),
          val:-1,
          val_partecipanti:-1,
          val_partecipanti_effettivi:-1,
          real_start:real_start.format("YYYY-MM-DD HH:mm:ss"),          
          real_end:real_end.format("YYYY-MM-DD HH:mm:ss"),
        });
      }
    }
  }

  return timeslots;
};

const updateTimeSlots = (timeslots, activities) => {
  const slotCounts = {};
  const slotPartecipanti = {};
  const slotPartecipantiEffettivi = {};

  activities.forEach(activity => {
    const { data_attivita, ora_inizio_attivita, ora_fine_attivita } = activity;
    let start = moment(`${data_attivita} ${ora_inizio_attivita}`, "YYYY-MM-DD HH:mm");
    let end = moment(`${data_attivita} ${ora_fine_attivita}`, "YYYY-MM-DD HH:mm");
    //console.log("ACT",activity);
    while (start.isBefore(end)) {
      const key = start.format("YYYY-MM-DD HH:mm");

      ////
      /*if(activity.stato_prenotazione_id==5){
        if (!slotPartecipanti[key]) {
          slotPartecipanti[key] = 0;
        }
        slotPartecipanti[key]++;
      }
      if(activity.stato_prenotazione_id==1||activity.stato_prenotazione_id==2||activity.stato_prenotazione_id==6){
        if (!slotPartecipantiEffettivi[key]) {
          slotPartecipantiEffettivi[key] = 0;
        }
        slotPartecipantiEffettivi[key]++;   
      }*/      
      //if(activity.stato_prenotazione_id==1 || activity.stato_prenotazione_id==5||activity.stato_prenotazione_id==2||activity.stato_prenotazione_id==6){
        /*if (!slotCounts[key]) {
          slotCounts[key] = 0;
        }*/

      /*slotCounts[key]++;   
      } */
      if(activity.stato_prenotazione_id==1 || activity.stato_prenotazione_id==5||activity.stato_prenotazione_id==2||activity.stato_prenotazione_id==6||activity.stato_prenotazione_id==4){
        if (!slotCounts[key]) {
          slotCounts[key] = 0;
        }
        if (!slotPartecipantiEffettivi[key]) {
          slotPartecipantiEffettivi[key] = 0;
        }
        if (!slotPartecipanti[key]) {
          slotPartecipanti[key] = 0;
        }        
        slotCounts[key]=slotCounts[key]+Number(activity.numero_partecipanti);   
        slotPartecipanti[key]=slotPartecipanti[key]+Number(activity.numero_partecipanti);   
        slotPartecipantiEffettivi[key]=slotPartecipantiEffettivi[key]+Number(activity.numero_partecipanti_effettivi);   
      }                        
      start.add(30, "minutes");
    }
  });
  //console.log("SCC",slotCounts, timeslots)
  
  return timeslots.map(slot => {
    const key = moment(slot.real_start).format("YYYY-MM-DD HH:mm");
    return {
      ...slot,
      val: slotCounts[key] || -1 ,
      val_partecipanti_effettivi:slotPartecipantiEffettivi[key] || -1,
      val_partecipanti:slotPartecipanti[key] || -1,
      //title: slotCounts[key] === -1 ? "" : slotCounts[key].toString(),            
      title: slotCounts[key] === -1 || slotCounts[key] === undefined ? "" : slotCounts[key].toString(),
    };
  });
};



function updateTimeSlotsWithSlots(firstArray, secondArray) {  
  const getDayOfWeek = (date) => {
    const daysOfWeek = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
    const day = new Date(date).getDay();
    return daysOfWeek[day];
  };
  
  const firstArrayMap = new Map();

  firstArray.forEach(item => {
    firstArrayMap.set(item.giorno, item);
  });
  
  return secondArray.map(item => {
    const dayOfWeek = getDayOfWeek(item.real_start);
    const matchingItem = firstArrayMap.get(dayOfWeek);    
    if (matchingItem) {
      //console.log("MI",dayOfWeek,matchingItem,item);      
      const time = item.real_start.substring(11, 16).replace(":", "");      
      if (matchingItem[time] > 0) {      
        if (item.val === -1) {
          return { ...item, val: 0, val_partecipanti:0, val_partecipanti_effettivi:0 };
        }
      }
    }          
    return item;
  });
};


  useEffect(() => {
    moment.locale("it");
    console.log("DATA",dataAttivita);
    console.log("PRENO",prenotazioni);    
    console.log("SLT",slots);    
                   
    if (prenotazioni && slots) {
      const res=[
      {id: 0,
        name: "Lunedì "+ moment(dataAttivita).format("DD/MM/YYYY")
      },
      {id: 1,
        name: "Martedì " + moment(dataAttivita).add(1, 'days').format("DD/MM/YYYY")
      },
      {id: 2,
        name: "Mercoledì " + moment(dataAttivita).add(2, 'days').format("DD/MM/YYYY")
      },
      {id: 3,
        name: "Giovedì " + moment(dataAttivita).add(3, 'days').format("DD/MM/YYYY")
      },
      {id: 4,
        name: "Venerdì " + moment(dataAttivita).add(4, 'days').format("DD/MM/YYYY")
      },
      {id: 5,
        name: "Sabato " + moment(dataAttivita).add(5, 'days').format("DD/MM/YYYY")
      },      
      {id: 6,
        name: "Domenica " + moment(dataAttivita).add(5, 'days').format("DD/MM/YYYY")
      },  
      ];

      const pren = slots.map(slot => ({          
        id: slot.id,
        name: slot.giorno
    }));

    const ev=generateTimeSlots(dataAttivita);
    const ev2=updateTimeSlots(ev,prenotazioni);
    const ev3=updateTimeSlotsWithSlots(slots,ev2);
    console.log("EV2",ev2);
    //console.log("EV3",ev3);
    //totale=ev3;
    //console.log("EV",ev,res);
   
        const newSchedulerData = createSchedulerData(ev3,res);
        setSchedulerData(newSchedulerData); 
        const timer = setTimeout(() => {
          setLoading(false);
        }, 100); 
      }
    
  }, [prenotazioni, slots, dataAttivita]);
  





const prevClick = () => {
  setLoading(true); 
    //const prevMonday = new Date(schedulerData.startDate);
    //prevMonday.setDate(prevMonday.getDate() - 7);
    const newDate = moment(dataAttivita).subtract(7, 'days').startOf('week').format("YYYY-MM-DD");
    //const newDate = moment(prevMonday).format("YYYY-MM-DD");
    setDataAttivita(newDate);
};

const nextClick = () => {
  setLoading(true); 
  //const newDate = moment(dataAttivita).add(1, 'days').format("YYYY-MM-DD");
  //const nextMonday = new Date(schedulerData.startDate);  
  //nextMonday.setDate(nextMonday.getDate() + 7);
    //const newDate = moment(dataAttivita).subtract(1, 'days').format("YYYY-MM-DD");
  //  const newDate = moment(nextMonday).format("YYYY-MM-DD");
    const newDate = moment(dataAttivita).add(7, 'days').startOf('week').format("YYYY-MM-DD");
    setDataAttivita(newDate);
};


const onSelectDate = (schedulerData, date) => {  
  setLoading(true); 
  const newDate = moment(date).startOf('week').format("YYYY-MM-DD")
  console.log(newDate);
  setDataAttivita(newDate);  
};



const eventItemPopoverTemplateResolver = (schedulerData,eventItem,title,start,end,statusColor) => {
  //return null;
  setIsPopoverVisible(true); 
  //console.log("WEI",eventItem)
  title=eventItem.label;

 
  const handleClick = function() {
    console.log("HC",eventItem);    
    setIsPopoverVisible(false); 
    
  }

  const handleClickExit = function() {
    console.log("HC",eventItem);   
    setIsPopoverVisible(false);     
  }

  if (!isPopoverVisible) {
    return null;  
  }
  return (    
    //console.log("OVERWORLD",eventItem),
    <div style={{ width: "300px" }}>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div
            className="status-dot"
            style={{ backgroundColor: statusColor }}
          />
        </Col>
        <Col span={22} className="overflow-text">
          <span className="header2-text" title={title}>
            {title}
          </span>
        </Col>
      </Row>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div />
        </Col>
        <Col span={22}>
          <span className="header1-text">
            {start.format("HH:mm")} - {end.format("HH:mm")}
          </span>
        </Col>
      </Row>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div />
        </Col>
        <Col span={22}>
        <div style={{ display:'flex', flexDirection: 'column', marginTop:'10px', marginBottom:'20px', width:'100%', gap: '10px'}}>
          <span className="header2-text">
              Partecipanti: {eventItem.val_partecipanti === -1 ? 0 : eventItem.val_partecipanti}               
          </span>
          <span className="header2-text">
              Partecipanti effettivi: {eventItem.val_partecipanti_effettivi  === -1 ? 0 : eventItem.val_partecipanti_effettivi}     
          </span>
         
          
          </div>
              
        </Col>
      </Row>
     
    </div>
  );
};

const eventItemTemplateResolver = (schedulerData, event, bgColor, isStart, isEnd, mustAddCssClass, mustBeHeight) => {
  //console.log("EITR",schedulerData, event, bgColor, isStart, isEnd, mustAddCssClass, mustBeHeight);
  const giorno = moment(event.start).format("dddd").toLowerCase(); 
  //console.log("GG",giorno);
  
  let backgroundColor = bgColor; // Mantiene il colore predefinito per gli altri giorni
  let pointerEvents = "auto"; // Abilitato per default

  //if (giorno === "lunedì") {
  //if (event.id === 20 && event.resourceId===3) {
  if (event.val === -1) {
    backgroundColor = "#FFF0F6"; 
    pointerEvents = "none"; 
  }
  if (event.val === 0) {
    backgroundColor = "#FFFFFF"; 
    pointerEvents = "none"; 
  }


  return (
    //console.log("ET",event.title),
    <div
      key={event.id}
      className={mustAddCssClass}
      style={{
        display: "flex",
        //alignItems: "center", 
        alignContent:"center",
        alignItems: "center", 
        //justifyContent: "center",
        //textAlign: "center", 
        width: "100%", 
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip", 
        backgroundColor,
        color: "white",
        //borderRadius: "0px",
        //padding: "0px",
        margin:"0px", 
        padding:"0px",       
        //alignItems: "center", 
        //justifyContent: "center", 
        //textAlign: "center",
        pointerEvents,
        height: mustBeHeight,
        fontSize: '0.9rem'
      }}      
    > <Typography   style={{
     paddingTop:"10px",
     paddingLeft:"8px",
      alignContent:"center",
      alignItems: "center", 
      justifyContent: "center",
      textAlign: "center", 
      width: "100%", 
      
      fontSize: '0.9rem'
    }}      >{event.title}</Typography>
    </div>
  );
};



  return (
    <div>
      {loading ? (
        <div style={{ width:"25%",   display: "flex", marginLeft: "auto", marginRight: "auto" }}>
          <ThreeDots color="#2196F3" height='350' width='150'/>
        </div>
      ):(
      <Scheduler        
        //key={reloadKey}
        schedulerData={schedulerData}
        prevClick={prevClick}
        nextClick={nextClick}
        onSelectDate={onSelectDate}       
        eventItemPopoverTemplateResolver = {eventItemPopoverTemplateResolver}    
        eventItemTemplateResolver = {eventItemTemplateResolver}                
      />
      )}
    </div>
  );
};

export default withDragDropContext(DashboardWeeklyView_7);
